import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  userName = "";
  password = "";
  errorMessage = "";

  constructor(
    private router: Router
  ) {
    localStorage.setItem('isLogin', null);
  }

  ngOnInit() {
  }

  login() {
    if (this.userName === 'admin' && this.password === 'OneSource1!') {
      localStorage.setItem('isLogin', 'true');
      localStorage.setItem('isAdmin', 'true');
      this.router.navigate(['/labor']);
    }
    // } else if (this.userName === 'user' && this.password === 'user') {
    //   localStorage.setItem('isLogin', 'true');
    //   localStorage.setItem('isAdmin', 'false');
    //   this.router.navigate(['/labor']);
    // }
    else {
      this.errorMessage = "Username or password is not correct.";
    }
  }
}
